import { Grid, Button, CircularProgress, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { AutoCompleter } from '../../../components/AutoCompleter/AutoCompleter'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { IPickingRoute } from '../../../interfaces/PickingRoute/PickingRoute'
import { useApi } from '../../../hooks/useApi'
import { UserPickers } from '../../../interfaces/User/User'
import { Status } from '../../../hooks/useFetchState'
import { getPickingAvailableUsers, patchResetPickingRoute, postReassignUserPicker } from '../api'

interface PickingRouteUserReassignProps {
  modalState: ModalReturnType<IPickingRoute>
  handleShowSnackbar: (msg: string | undefined, status: boolean) => void 
  fetchDataGrid:()=> void
}

export const PickingRouteUserReassign: React.FC<
  PickingRouteUserReassignProps
> = ({ modalState, handleShowSnackbar, fetchDataGrid }) => {
  const { state, callApi } = useApi<UserPickers[]>()

  const {
    state: reassignPickingUserState,
    callApi: reassignPickingUserCallApi
  } = useApi()
  
  const {
    state : resetPickingRoute,
    callApi: patchResetPickingRouteApi
  } = useApi()

  const [selectedUserPicker, setSelectedUserPicker] = useState<UserPickers>()

  const requestGetPickingAvailableUsers = () => {
    if (modalState.extendedProps) {
      callApi(getPickingAvailableUsers(modalState.extendedProps?.zoneId))
    }
  }

  const requestPostReassignUserPicker = () => {
    reassignPickingUserCallApi(
      postReassignUserPicker(
        modalState.extendedProps?.pickingRouteId || 0,
        selectedUserPicker?.userId || 0        
      )
    )
      .then(() => {
        handleShowSnackbar('Usuario reasignado correctamente', true)
        fetchDataGrid()
        modalState.closeModal()
      })
      .catch((err) =>
        handleShowSnackbar(`No fue posible reasigna usuario: ${err}`, false)
      )
  }

  const requestPatchResetPickingRoute = () => {
    if (modalState.extendedProps) {
      patchResetPickingRouteApi(
        patchResetPickingRoute(modalState.extendedProps?.pickingRouteId)
      )
        .then(() => {
          handleShowSnackbar('Ruta Liberada correctamente', true)
          fetchDataGrid()
          modalState.closeModal()
        })
        .catch((err) => handleShowSnackbar(`${err}`, false))
    }
  }

  useEffect(() => {
    if (modalState.isOpen && modalState.extendedProps) {
      requestGetPickingAvailableUsers()
    }
  }, [modalState.isOpen, modalState.extendedProps])

  const handleChangeUserPicker = (userPicker: string) => {
    const userPickerFind = (state.data || []).find(
      (x) => x.userName === userPicker
    )

    setSelectedUserPicker(userPickerFind)
  }

  return (
    <Modal onClose={modalState.closeModal} open={modalState.isOpen}>
      <Grid
        container
        direction='row'
        spacing={2}
        justifyContent='flex-end'
        alignItems='center'
      >
        <Grid item xs={12} sm={12} lg={8} md={8}>
          <AutoCompleter
            item={(state.data || []).map((item: any) => {
              return {
                value: item.userName
              }
            })}
            nameList={'userName'}
            labelList={'Usuarios Pickeadores'}
            isLoader={state.status === Status.Loading}
            handleChange={(e: any) => {
              handleChangeUserPicker(e.target.value)
            }}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        spacing={2}
        justifyContent='flex-end'
        alignItems='center'
        style={{ marginTop: '20px' }}
      >
        <Grid item xs={12} sm={12} lg={8} md={8}>
          <Button
            variant='contained'
            onClick={() => {
              if (modalState.extendedProps) {
                requestPostReassignUserPicker()
              }
            }}
            style={{ marginLeft: 10 }}
            color='primary'
            startIcon={
              reassignPickingUserState.status === Status.Loading ? (
                <CircularProgress size='0.9rem' />
              ) : undefined
            }
            disabled={reassignPickingUserState.status === Status.Loading || resetPickingRoute.status === Status.Loading}
          >
            Reasignar Picker
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} lg={8} md={8}>
          <Button
            variant='contained'
            onClick={() => {
              if (modalState.extendedProps) {
                requestPatchResetPickingRoute()
              }
            }}
            style={{ marginLeft: 10 }}
            color='primary'
            startIcon={
              resetPickingRoute.status === Status.Loading ? (
                <CircularProgress size='0.9rem' />
              ) : undefined
            }
            disabled={resetPickingRoute.status === Status.Loading || reassignPickingUserState.status === Status.Loading}
          >
            Liberar Ruta
          </Button>
        </Grid>
      </Grid>
      {state.data?.length === 0 && (
        <Grid
          container
          direction='row'
          spacing={2}
          justifyContent='center'
          alignItems='center'
          style={{ marginTop: '20px' }}
        >
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <Typography variant='h6' component={'p'} style={{ color: 'red' }}>
              Debe seleccionar un usuario pickeador
            </Typography>
          </Grid>
        </Grid>
      )}
    </Modal>
  )
}
